var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('preview-input-string',{attrs:{"name":_vm.name,"value":_vm.value,"lineBreak":typeof _vm.value === 'string' && _vm.value.length > 70 ? 'long' : 'auto'}})}
var staticRenderFns = []

export { render, staticRenderFns }